export default __webpack_public_path__ + "static/media/inlab-en.9044a18a.svg";